var exports = {
  "spinner": "Spinner.module__spinner___SnBvNi",
  "spinnerInner": "Spinner.module__spinnerInner___SnBvNi",
  "spinnerItem": "Spinner.module__spinnerItem___SnBvNi",
  "spinnerPulsingEllipsis": "Spinner.module__spinnerPulsingEllipsis___SnBvNi",
  "small": "Spinner.module__small___SnBvNi",
  "medium": "Spinner.module__medium___SnBvNi",
  "large": "Spinner.module__large___SnBvNi",
  "delay1": "Spinner.module__delay1___SnBvNi",
  "delay2": "Spinner.module__delay2___SnBvNi",
  "srOnly": "Spinner.module__srOnly___SnBvNi",
};

__webpack_require__.r(module.exports = exports);
